
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.667 3.96H17c.917 0 1.667.75 1.667 1.667v10c0 .917-.75 1.667-1.667 1.667H3.667c-.917 0-1.667-.75-1.667-1.667v-10c0-.917.75-1.667 1.667-1.667z","stroke":"#000","stroke-width":"1.667","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.667 5.627l-8.334 5.833L2 5.627","stroke":"#000","stroke-width":"1.667","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    